/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { WorkingModeApplyRequestTarget } from './workingModeApplyRequestTarget';
import type { WorkingModeApplyRequestExpectedEtag } from './workingModeApplyRequestExpectedEtag';

export interface WorkingModeApplyRequest {
  target: WorkingModeApplyRequestTarget;
  expectedEtag?: WorkingModeApplyRequestExpectedEtag;
}
